import React, { useEffect } from "react";
import "./status-modal.m.css";

const StatusModal = ({ type, redirectUrl, onClose }) => {
  useEffect(() => {
    if (redirectUrl) {
      const t = setTimeout(() => window.location.replace(redirectUrl), 3000);
      return () => clearTimeout(t);
    }
  }, [redirectUrl]);

  const isA = type === "active", isC = type === "campaign_expired";
  return (
    <div styleName="modal-overlay">
      <div styleName="modal-container">
        <div styleName="icon-wrapper"><svg width="40" height="40" viewBox="0 0 24 24" fill="none"><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2"/><path d="M12 8V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M12 16H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg></div>
        <h3 styleName="title">{isA ? "Active Subscription Found" : isC ? "Campaign Expired" : "Subscription Expired"}</h3>
        <p styleName="message">{isA ? "You already have an active subscription with us." : isC ? "This campaign has ended." : "Your previous subscription has expired."}</p>
        {redirectUrl ? (
          <>
            <div styleName="redirect-info" style={{ marginBottom: "16px" }}><span styleName="loader" />Redirecting you in a moment...</div>
            <a styleName="close-btn" href={redirectUrl} style={{ textDecoration: "none", display: "flex", justifyContent: "center", alignItems: "center", boxSizing: "border-box" }}>Redirect</a>
          </>
        ) : (
          <button styleName="close-btn" onClick={onClose} type="button">Close</button>
        )}
      </div>
    </div>
  );
};
export { StatusModal };
